import createReducer from 'redux/createReducer';
import { SET_ROLLOUTS } from '../actions/types';
import { setRollouts } from './set-rollouts';

const actionTypeReducerMap = new Map();
actionTypeReducerMap.set(SET_ROLLOUTS, setRollouts);

export default createReducer({}, actionTypeReducerMap);
